export default __webpack_public_path__ + "static/media/resume-redacted.6bfcba11.pdf";